module.exports = __webpack_public_path__ + "ie.svg?bae8083c4528f76f1ab53e7a5ae0bfb2";